import { render } from "./Score_Adm.vue?vue&type=template&id=408f1c1d"
import script from "./Score_Adm.vue?vue&type=script&lang=js"
export * from "./Score_Adm.vue?vue&type=script&lang=js"

import "./Score_Adm.vue?vue&type=style&index=0&id=408f1c1d&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/dynamik_webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__